
export interface IResourceTabProps {
  
}

export enum ETabList {
  LIST = "List",
  FLOOR_PLAN = "Floor Plan"
}
